import { CanvasJSChart } from 'canvasjs-react-charts'
import * as R from 'ramda';
import React, { useEffect, useState } from 'react';

function FunnelChart({ title, dataPoints, extractX, extractY }) {
	const [processedPoints, setProcessedPoints] = useState([]);

	useEffect(() => {
		let processedPoints = R.map(dataPoint => ({ label: extractX(dataPoint), y: extractY(dataPoint )}))(dataPoints);
		setProcessedPoints(processedPoints);
	}, [dataPoints]);

	const options = {
		animationEnabled: true,
		exportEnabled: true,
		theme: "light2", // "light1", "dark1", "dark2"
		title:{
			text: title
		},
		data: [{
			type: 'funnel',
            toolTipContent: "<b>{label}</b>: {y} <b>({percentage}%)</b>",
            indexLabelPlacement: "inside",
            indexLabel: "{label} ({percentage}%)",
			dataPoints: processedPoints
		}]
	}

    if (processedPoints.length > 0) {
        let dataPoint = options.data[0].dataPoints;
        let total = dataPoint[0].y;
        for(let i = 0; i < dataPoints.length; i++) {
            if(i == 0) {
                options.data[0].dataPoints[i].percentage = 100;
            } else {
                options.data[0].dataPoints[i].percentage = ((dataPoint[i].y / total) * 100).toFixed(2);
            }
        }
    }

	return (
		<div>
			<CanvasJSChart options = {options}/>
		</div>
	);
}
export default FunnelChart;